export default __webpack_public_path__ + "static/media/andersonPaak.7ac1a55a.jpeg";